import type { FetchSubPartnersQuery } from '@/features/sub-partners/api'
import type { SubPartnersListSearch } from '@/routes/_protected/$tenantKey/settings/sub-partners/-models'

export function buildFetchSubPartnersQuery(
  tenantKey: string,
  deps: SubPartnersListSearch
): FetchSubPartnersQuery {
  return {
    tenantKey,
    query: {
      ...deps
    }
  }
}
